// extracted by mini-css-extract-plugin
export var card = "_aj-0";
export var expandedCard = "_aj-2";
export var paginated = "_aj-1";